import { ConfirmModalComponent } from '../../../common/confirm-modal/confirm-modal.component';
import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreIputWithValidationComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-input-with-validation/mapfre-input-with-validation.component';
import { TooltipComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/section-components/tooltip/tooltip.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormGroup , FormsModule , ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router , RouterModule } from '@angular/router';
import { FormBase, FormBaseControlService } from '@mapfre-design-library/src/public_api';
import { BillingStuffService } from '@services/billing-stuff.service';
import { Constants } from '@models/constants';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, TooltipComponent, MapfreIputWithValidationComponent, MapfreButtonComponent, ConfirmModalComponent],
  selector: 'app-paperless-billing-stuff-enroll-form',
  templateUrl: './paperless-billing-stuff-enroll-form.component.html',
  styleUrls: ['./paperless-billing-stuff-enroll-form.component.scss']
})
export class PaperlessBillingStuffEnrollFormComponent implements OnInit {
  paperlessEnrollForm: FormGroup;
  inputs: FormBase<any>[] = [];
  loader: boolean;
  showConfirmModal: boolean;
  isTermsAcccepted: boolean;
  enrollData: any;
  retryAttemt: boolean;
  
  constructor(
    private fbcs: FormBaseControlService,
    private bsService: BillingStuffService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { 
    this.inputs = this.bsService.getInputs();
    this.loader = false;
    this.showConfirmModal = false;
    this.isTermsAcccepted = false;
    this.retryAttemt = false;
  }
  
  onError(err) {
    if(err && err.error) {
      if(err.error.Message === Constants.DATA_MISMATCHED ||
        err.error.Message === Constants.POLICY_NOT_LOCATED ) {
        this.router.navigate(['/paperless', 'does-not-match']);
      }
      else if(err.error.Message === Constants.ENROLL_FAILED) {
        this.router.navigate(['/paperless', 'enrollment-request-sent']);
      }
      else if(err.error.Message === Constants.ENROLLED_ALREADY) {
        this.router.navigate(['/paperless', 'already-enrolled'], {
          queryParams: { isAlreadyEnrolled: true }
        });
      }
    }
  }
  onSuccess() {
    this.router.navigate(['/paperless', 'enrollment-success']);
  }
  consturctEnrollata(object) {
    this.enrollData = {
      user: {
        "firstName": object.signUpFirst_name.trim(),
        "middleName": "",
        "lastName": object.signUpLast_name.trim(),
        "dateOfBirth": object.enrollDob,
        "email": {
          "email": object.createAc_email
        },
        "zipCode": object.noPhoneEmail_zipcode
      },
      policyNumber: object.addPolicyOnSignUp
    } 
    this.bsService.setEnrollData(this.enrollData);
  }
  enroll() {
    this.loader = true;
    this.consturctEnrollata(this.paperlessEnrollForm.value);
    this.bsService.enrollPaperless(
      this.retryAttemt,
      this.enrollData?.user,
      this.paperlessEnrollForm.value.addPolicyOnSignUp).subscribe(() => {
        this.loader = false;
        this.onSuccess();
      }, err=> {
        this.loader = false;
        this.onError(err);
      });
  }
  cancel() {
    this.showConfirmModal = true;
  }
  onCloseConfirmModal() {
    this.showConfirmModal = false;
  }
  isCheckBoxChecked(event) {
    this.isTermsAcccepted = event?.target?.checked;
  }

  prefillData(): void {
    this.bsService.getEnrollData().subscribe((enrollData: any) => {
      if (enrollData && enrollData?.user) {
        this.paperlessEnrollForm.controls.signUpFirst_name.setValue(
          enrollData?.user?.firstName
        );
        this.paperlessEnrollForm.controls.signUpLast_name.setValue(
          enrollData?.user?.lastName
        );
        this.paperlessEnrollForm.controls.enrollDob.setValue(
          enrollData?.user?.dateOfBirth
        );
        this.paperlessEnrollForm.controls.noPhoneEmail_zipcode.setValue(
          enrollData?.user?.zipCode
        );
        this.paperlessEnrollForm.controls.createAc_email.setValue(
          enrollData?.user?.email?.email
        );
        this.paperlessEnrollForm.controls.addPolicyOnSignUp.setValue(
          enrollData?.policyNumber
        );
      }
    });
  }
  getRetryAttemptFlag() {
    this.activatedRoute.queryParams.subscribe((queryParams) => {
      if (queryParams['retryAttempt'] === "true") {
        this.retryAttemt = true;
      }
    });
  }
  ngOnInit(): void {
    this.paperlessEnrollForm = this.fbcs.toFormGroup(this.inputs);
    this.prefillData();
    this.getRetryAttemptFlag();
  }

}
